export interface Pantone {
	name: string;
	r: number;
	g: number;
	b: number;
}

export const getPantoneColours = async () => {
	const pantone = await import('./pantoneList.json');
	return (pantone.default ?? pantone) as Pantone[];
};

export function getClosestPantone(pixel: number[], colours: Pantone[]) {
	let closestPantone: Pantone = colours[0];
	let closestDistance = Infinity;

	for (const p of colours) {
		const distance = Math.sqrt(Math.pow(p.r - pixel[0], 2) + Math.pow(p.g - pixel[1], 2) + Math.pow(p.b - pixel[2], 2));
		if (distance < closestDistance) {
			closestPantone = p;
			closestDistance = distance;
		}
	}

	return closestPantone;
}

export function getClosestPantoneAsPixel(pixel: number[], colours: Pantone[]) {
	const closest = getClosestPantone(pixel, colours);
	return [closest.r, closest.g, closest.b];
}

export function mapToPantone(image: ImageData, colours: Pantone[]) {
	const pantonePixels: number[][] = [];

	for (let i = 0; i < image.data.length; i += 4) {
		const pixel = [image.data[i], image.data[i + 1], image.data[i + 2]];
		const closest = getClosestPantone(pixel, colours);
		pantonePixels.push([closest.r, closest.g, closest.b]);
	}

	return pantonePixels;
}

export function pantoneToPixel(pantone: Pantone): number[] {
	return [pantone.r, pantone.g, pantone.b];
}

export function pixelToPantone(pixel: number[], colours: Pantone[]): Pantone {
	return getClosestPantone(pixel, colours);
}

export function pantoneToRGBA(pantone: Pantone) {
	return {
		r: pantone.r / 255,
		g: pantone.g / 255,
		b: pantone.b / 255,
		a: 1,
	};
}

export function pantoneToHex(pantone: Pantone) {
	return `#${((1 << 24) + (pantone.r << 16) + (pantone.g << 8) + pantone.b).toString(16).slice(1)}`;
}
